// Helper functions for signature auto-population
import { getUserSignature } from '../_services/user.service';

export const autoPopulateSignature = async (formState, setFormState, signatureFieldName) => {
  try {
    // Get current signature value
    const currentSignature = formState[signatureFieldName];

    // Only auto-populate if the current form doesn't already have a signature
    if (!currentSignature || currentSignature === '' || currentSignature === null) {
      const response = await getUserSignature();
      
      if (response.success && response.signature) {
        // Pass the signature directly, not wrapped in an object
        setFormState(response.signature);
      } else {
        console.log('Response failed or no signature:', {
          success: response.success,
          hasSignature: !!response.signature,
          signatureLength: response.signature ? response.signature.length : 0
        });
      }
    }
  } catch (error) {
    console.error('Error auto-populating signature:', error);
  }
}; 